import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface CanvasProps extends ComponentPropsWithRef<"div"> {}

export const CanvasCard = forwardRef<HTMLDivElement, CanvasProps>(
  ({ children, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames(
        "border-primary bg-primary relative isolate w-full rounded-lg border shadow-lg",
        className,
      )}
      data-testid="canvas-card"
      {...rest}
    >
      {children}
    </div>
  ),
);
CanvasCard.displayName = "CanvasCard";
